import { useState } from "react";

const useDrawer = () => {
  const [isDrawerVisible, setDrawerVisible] = useState(false);

  const toggleDrawer = (state) => {
    typeof state === "boolean" ? setDrawerVisible(state) : setDrawerVisible(!isDrawerVisible);
  };

  return { isDrawerVisible, toggleDrawer };
};

export default useDrawer;
